import type { OmniAuthAuthorize } from '@mint-sdk/api-omni';

export type AmazonRegion = OmniAuthAuthorize.AmazonRegionsList;

export const AMAZON_REGION_OPTIONS: { value: AmazonRegion; label: string }[] = [
  { value: 'north_america', label: 'North America' },
  { value: 'europe', label: 'Europe' },
  { value: 'far_east', label: 'Far East' },
];

export const isAmazonRegion = (value: unknown): value is AmazonRegion =>
  AMAZON_REGION_OPTIONS.some((option) => option.value === value);
